import type { Aluno } from '@/domain/model/Aluno';
import type { UploadAlunoFotoUseCase } from '@/application/port/in/UploadAlunoFotoUseCase';
import type { AlunoGateway } from '@/application/port/out/AlunoGateway';

export class UploadAlunoFoto implements UploadAlunoFotoUseCase {
  constructor(private readonly gateway: AlunoGateway) {}
  execute(alunoId: string, file: File): Promise<Aluno> {
    return this.gateway.uploadFoto(alunoId, file);
  }
}
